// extracted by mini-css-extract-plugin
export var statItem = "_jb-1";
export var statsRow = "_jb-0";